if (!customElements.get('fika-cart-rotation')) {
    customElements.define('fika-cart-rotation',class extends HTMLElement {
      static busy=false;
      connectedCallback() {
        this.controller?.abort();this.controller=new AbortController();
        this.addEventListener('submit',event=>this.add(event),{signal:this.controller.signal});
      }
      disconnectedCallback(){this.controller?.abort();}
      async add(event) {
        if (!(event.target instanceof HTMLFormElement)) return;
        event.preventDefault();event.stopPropagation();
        if(this.constructor.busy)return;
        this.constructor.busy=true;
        document.querySelectorAll('fika-cart-rotation button').forEach(button=>button.disabled=true);
        const root=window.Shopify?.routes?.root||'/';
        try {
          const body={items:[{id:Number(new FormData(event.target).get('id')),quantity:1}]};
          const sections=[...new Set([...document.querySelectorAll('cart-items-component')].map(el=>el.dataset.sectionId).filter(Boolean))];
          if(sections.length)body.sections=sections.slice(0,5);
          body.sections_url=location.pathname;
          const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
          const added=await response.json();
          if(!response.ok)throw new Error(added.description||added.message);
          const cartResponse=await fetch(root+'cart.js');
          if(!cartResponse.ok)throw new Error(cartResponse.statusText);
          const cart=await cartResponse.json();
          document.dispatchEvent(new CustomEvent('cart:update',{detail:{resource:cart,sourceId:'fika-cart-rotation',data:{source:'fika-cart-rotation',sections:added.sections,itemCount:cart.item_count}}}));
        } catch(error){this.querySelector('[role=alert]').textContent=error.message;}
        finally {this.constructor.busy=false;document.querySelectorAll('fika-cart-rotation button').forEach(button=>button.disabled=false);}
      }
    });
  }
